import { Component, OnInit, TemplateRef, AfterViewInit, ElementRef, NgZone, Renderer2, Inject } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
//Encrypt and Decrypt
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { SigninSignUpService } from '../_Service/UsersSignInSignUp/signin-sign-up.service';
import * as moment from 'moment';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css']
})
export class LandingpageComponent implements OnInit, AfterViewInit {

  help_center = environment.help_center;
  terms_condition = environment.terms_and_condition;
  privacy_policy = environment.privacy_policy;
  site_map = environment.siteMap_link;
  news_site_map = environment.news_site_map;
  loadAPI: Promise<any>;
  loadCssAPI: Promise<any>;
  //Login User Check valriable(n) 
  checkLoginUser: any;
  loadCss: boolean = false;
  year: any = '';


  title: any;
  merged_title: any;
  description: any;
  platform_name_seprated: any;
  platform_name: any;
  platform_logo: any;
  countryFlags: any[];
  phoneCode: any;
  homeContent: any;
  faq_name: any;

  meta_logo: any;
  landing_seo: any;
  project_url: any;
  platform_icon: any;
  svg: any;
  pals_bg: any;
  faqUrl: any;
  ageFontColor: string = "text-dark"
  video_muted: boolean = false;
  controls: any;
  video_android: boolean;
  modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private route: Router,
    private _SigninSignUp: SigninSignUpService,
    private titleService: Title,
    private metaTagService: Meta,
    private elementRef: ElementRef,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) {

    document.getElementsByTagName("HTML")[0].setAttribute("data-wf-page", "5eb415b660483b06717ef692");

    this.year = '';
    this.meta_logo = environment.home_meta;
    this.landing_seo = environment.landing_seo;
    this.platform_name = environment.platform_name;
    this.platform_name_seprated = environment.faq_name;
    this.faq_name = environment.faq_name;
    this.homeContent = environment.homeContent;
    this.project_url = environment.project_url;
    this.svg = environment.svg;
    this.pals_bg = environment.pals_bg;
    this.faqUrl = environment.faqUrl;

    // this.title = this.platform_name + '| Sports Social Media and Sports Statistics';
    // this.description = " provides real-time sporting statistics, follow your favorite teams or players and interact with other fans.";
    this.title =  'Live Scores & Social Sports News Updates | ' + this.platform_name ;
    this.merged_title = this.platform_name + ': Sports Social Media and Sports Statistics';
    this.description = " Never miss a play! it'sgametime delivers the latest sports news, live scores, and real-time updates. Stay on top of your favorite teams and leagues.";
    this.titleService.setTitle(this.title);
    this.metaTagService.addTag({ name: 'keywords', content: "real time sports, NFL, MLB baseball, football, soccer" });
    this.metaTagService.addTag({ name: 'description', content: this.platform_name + this.description });

    this.metaTagService.addTag({ name: 'robots', content: 'all' });

    this.metaTagService.addTag({ property: 'og:locale', content: 'en_US' });
    this.metaTagService.addTag({ property: 'og:card', content: 'summary_large_image' });
    this.metaTagService.addTag({ property: 'og:site_name', content: this.platform_name });
    this.metaTagService.addTag({ property: 'og:title', content: this.title });
    this.metaTagService.addTag({ property: 'og:description', content: this.platform_name + this.description });
    this.metaTagService.addTag({ property: 'og:url', content: this.project_url });
    this.metaTagService.addTag({ property: 'og:image', content: this.project_url + '' + this.landing_seo });
    this.metaTagService.addTag({ property: 'og:image:width', content: '1200' });
    this.metaTagService.addTag({ property: 'og:image:height', content: '630' });
    this.metaTagService.addTag({ property: 'og:image:alt', content: this.platform_name + this.description });

    this.metaTagService.addTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaTagService.addTag({ name: 'twitter:site_name', content: this.platform_name });
    this.metaTagService.addTag({ name: 'twitter:title', content: this.title });
    this.metaTagService.addTag({ name: 'twitter:description', content: this.platform_name + this.description });
    this.metaTagService.addTag({ name: 'twitter:url', content: this.project_url });
    this.metaTagService.addTag({ name: 'twitter:image', content: this.project_url + '' + this.landing_seo });
    this.metaTagService.addTag({ name: 'twitter:image:width', content: '800' });
    this.metaTagService.addTag({ name: 'twitter:image:height', content: '480' });
    this.metaTagService.addTag({ name: 'twitter:image:alt', content: this.platform_name + this.description });

    this.removejscssfile("its-game-time.js", "js");
    this.removejscssfile("normalize.css", "css");
    this.removejscssfile("components.css", "css");
    this.removejscssfile("its-game-time.css", "css");



    this.loadCssAPI = new Promise((resolve) => {
      this.addandLoadCss();
      resolve(true);
    });



    this.loadCss = true;
    //Login User Check(n) 
    if (localStorage.getItem("token") && localStorage.getItem("token") != 'undefined') {
      this._SigninSignUp.checkUserLogin().subscribe(
        res => {
          if (localStorage.getItem("tokenAdmin") && localStorage.getItem("tokenAdmin") != 'undefined') {
            this.route.navigate(['/admin1987/login']);
          } else {

            localStorage.setItem("userProfileType", this.encryptData('Main'));
            localStorage.setItem("activeTab", this.encryptData('Pals'));
            this.route.navigate(['/index']);
          }
        }, (err) => {
          this.checkLoginUser = true;
          localStorage.clear();
        });
    } else {
      this.checkLoginUser = true;
    }
    //Login User Check(n) 

    document.getElementsByTagName("HTML")[0].setAttribute("data-wf-page", "5eb415b660483b06717ef692");

    this.elementRef.nativeElement.ownerDocument.body.style.background = "url('')";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundAttachment = "fixed";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundSize = "cover";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundPosition = "center";

  }

  removejscssfile(filename, filetype) {
    let targetelement = (filetype == "js") ? "script" : (filetype == "css") ? "link" : "none" //determine element type to create nodelist from
    let targetattr = (filetype == "js") ? "src" : (filetype == "css") ? "href" : "none" //determine corresponding attribute to test for
    let allsuspects = document.getElementsByTagName(targetelement)
    for (let i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
      if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
  }

  //Encrypt Data(n)
  encryptData(data) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), '1234509876encryptdecrypt1234567890').toString();
    } catch (e) {
    }
  }
  //End encrypt Data(n)
  //Decrypt Data (n)
  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, '1234509876encryptdecrypt1234567890');
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
    }
  }
  //End Decrypt Data (n)

  ngOnInit() {
    this.year = moment().year();
    let chatFrame = document.getElementById('launcher');
    if (chatFrame) {
      chatFrame.style.display = 'block';
    }
  }

  mediaModalOpen(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered lightbox-modal modal-xl', backdrop: true,
      ignoreBackdropClick: false
    });
  }

  public loadScript() {
    let isFound = false;
    let isZenFound = false;
    let scripts = document.getElementsByTagName("script")
    for (let i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('class') && scripts[i].getAttribute('class').includes("itsgametimeJs")) {
        isFound = true;
      }
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('id') && scripts[i].getAttribute('id').includes("ze-snippet")) {
        isZenFound = true;
      }
    }

    if (!isZenFound) {
      for (let i = 0; i < 1; i++) {
        let node = this._renderer2.createElement('script');
        node.src = "https://static.zdassets.com/ekr/snippet.js?key=c5242f06-7a58-433e-8c74-f311b26c7c81";
        node.id = 'ze-snippet';
        node.type = 'text/javascript';
        node.className = 'w-json'
        node.async = true;
        this._renderer2.appendChild(this._document.body, node);
      }
    }

    if (!isFound) {
      let dynamicScripts = [

        "../../assets/landing-js/its-game-time.js",
      ];

      for (let i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.className = 'itsgametimeJs';
        node.charset = 'utf-8';
        document.getElementsByTagName('body')[0].appendChild(node);
      }


    }
  }

  public addandLoadCss() {
    let isFoundCss = false;
    let linkArray = document.getElementsByTagName("link");
    for (let i = 0; i < linkArray.length; i++) {
      if (linkArray[i].getAttribute('href') != null && linkArray[i].getAttribute('id') && linkArray[i].getAttribute('id').includes("itsGameTimeCss")) {
        isFoundCss = true;
      }
    }

    if (!isFoundCss) {
      let dynamicCss = [

        "../../assets/landing-css/normalize.css",
        "../../assets/landing-css/components.css",
        "../../assets/landing-css/its-game-time.css",
      ];

      for (let i = 0; i < dynamicCss.length; i++) {
        let link = document.createElement('link');
        link.rel = "stylesheet";
        link.type = 'text/css';
        link.id = "itsGameTimeCss" + i;
        link.href = dynamicCss[i];
        document.head.appendChild(link);
      }
    }
    this.loadScript();
  }

  ngAfterViewInit() {
    scrollTo(10, 10);
    setTimeout(() => {
      scrollTo(0, 0);
    }, 1000);
  }

  ngOnDestroy() {
    let chatFrame = document.getElementById('launcher');
    if (chatFrame) {
      chatFrame.style.display = 'none';
    }
    this.removejscssfile("its-game-time.js", "js");
    this.removejscssfile("normalize.css", "css");
    this.removejscssfile("components.css", "css");
    this.removejscssfile("its-game-time.css", "css");
  }

}
